import { render, staticRenderFns } from "./AtopicDermatitisHospitalizationsPhase.vue?vue&type=template&id=4d33190f&scoped=true&"
import script from "./AtopicDermatitisHospitalizationsPhase.vue?vue&type=script&lang=js&"
export * from "./AtopicDermatitisHospitalizationsPhase.vue?vue&type=script&lang=js&"
import style0 from "./AtopicDermatitisHospitalizationsPhase.vue?vue&type=style&index=0&id=4d33190f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d33190f",
  null
  
)

export default component.exports